import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChange } from '@angular/core';

import { ModalDirective } from 'ng2-bootstrap/modal';

import { UsuariosService } from '../_services/usuarios.service';
import { CentrosDeTrabajoService } from '../_services/centrosdetrabajo.service';

declare var jQuery: any;

@Component({
  selector: 'modalusuariosct',
  templateUrl: './modalusuariosct.component.html',
  styleUrls: ['./modalusuariosct.component.css']
})
export class ModalusuariosctComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() _mostrarmodal: any;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;
  @Output() onChangeModal = new EventEmitter<any>();
  @Input() _id_empresa: any;

  public filterQuery = "";
  public filterQueryEvidencias = "";

  mostrarmodal: boolean = false;
  listausuariosseleccionados: any = [];
  listausuarios: any = [];

  listacentros: any = [];
  centrodetrabajoseleccionado: number = 0;

  constructor(
    private usuariosService: UsuariosService,
    private centrosdetrabajoService: CentrosDeTrabajoService
  ) { }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_mostrarmodal']){
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }

    this.getListaUsuarios();
    this.getListaCentrosDeTrabajo();

  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.abrirModal();
  }

  abrirModal(){
    if (this.mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(guardar: boolean){
    if (!guardar){
      this.listausuariosseleccionados = [];
    }
    this.staticModalRespuestas.hide();

    let emit = {
      id_ct: this.centrodetrabajoseleccionado,
      usuarios: this.listausuariosseleccionados
    }

    this.onChangeModal.emit(emit);
  }

  getListaUsuarios(){
    this.usuariosService.getListaUsuarios().subscribe(
        data => {
          if (data){

            this.listausuarios = data.json().lista;
            console.log(this.listausuarios);
          }
        }
    );
  }

  getListaCentrosDeTrabajo(){
    this.centrosdetrabajoService.getListaCentrosDeTrabajoEmpresa(this._id_empresa).subscribe(
        data => {
          if (data){
            this.listacentros = data.json().lista;
          }
        }
    );
  }

  anadirUsuario(usuario: any, event: any){

    let encontrado: number;

    if (jQuery('#check_'+event).is(':checked')) {
      this.listausuariosseleccionados.push(usuario);
    }else{
      for (let i = 0; i < this.listausuariosseleccionados.length; i++) {
        if (this.listausuariosseleccionados[i].id_usuario == usuario.id_user){
          encontrado = i;
        }

      }

      this.listausuariosseleccionados.splice(encontrado,1);
    }

    console.log(this.listausuariosseleccionados);

  }

}



// WEBPACK FOOTER //
// ./src/app/modalusuariosct/modalusuariosct.component.ts